import {
  type IAudioContext,
  type IMediaStreamAudioDestinationNode,
} from 'standardized-audio-context';
import { v4 as uuid } from 'uuid';
import { type StateCreator } from 'zustand';
import { type AudioGraphStore } from './types';

export interface StreamListener {
  id: string;
  onInterruption?: () => void;
}

export interface RecordingSlice {
  listeners: StreamListener[];
  recorderDestinationNode: IMediaStreamAudioDestinationNode<IAudioContext> | null;
  getRecorderStream: (onInterruption?: () => void) => {
    id: string;
    stream: MediaStream;
  };
  releaseStream: (listenerId: string) => void;
}

export const createRecordingSlice: StateCreator<
  AudioGraphStore,
  [],
  [],
  RecordingSlice
> = (set, get) => ({
  listeners: [],
  recorderDestinationNode: null,

  releaseStream: (id) => {
    set((s) => ({
      listeners: s.listeners.filter((listener) => listener.id !== id),
    }));

    get().cleanupResourcesIfUnused();
  },

  getRecorderStream: (onInterruption) => {
    const id = uuid();
    set((s) => ({ listeners: [...s.listeners, { id, onInterruption }] }));
    return { id, stream: get().recorderDestinationNode!.stream };
  },
});
